import $ from 'jquery';
import { utils } from '../common/utils';

export class AlertBox {
    private $alert: JQuery<HTMLElement>;

    constructor(element: HTMLElement | JQuery<HTMLElement>) {
        this.$alert = utils.isJquery(element) ? element : $(element);
    }

    setText(text: string): void {
        this.$alert.html(text);
    }

    clear(): void {
        this.$alert.html('');
    }

    show(): void {
        this.$alert.removeClass('d-none');
        utils.scrollTo(this.$alert);
    }

    hide(): void {
        this.$alert.addClass('d-none');
    }
}
